/** Batch POST to `/auth/sse-acknowledge` (proxies to gamification acknowledge). */

export const XP_ACK_DEBOUNCE_MS = 200;

export async function postXpAcknowledgements(ids: string[]): Promise<void> {
  if (ids.length === 0) {
    return;
  }

  try {
    await fetch('/auth/sse-acknowledge', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids }),
    });
  } catch (err) {
    console.warn('[SSE] Failed to acknowledge events:', ids, err);
  }
}
